module.exports = __webpack_public_path__ + "img/ZEAMAPlogo.8757a758.svg";